import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo_bitramp from "../assets/LogoBitramp.svg";
import { isBitramp } from "@/utils/utils";

const CRMsoon: React.FC = () => {
  useEffect(() => {
    const themeClass = isBitramp() ? "theme-bitramp" : "theme-leonext";
    document.body.classList.add(themeClass);

    return () => {
      document.body.classList.remove("theme-bitramp");
    };
  }, []);
  const navigate = useNavigate();
  return (
    <div
      className={
        "bg-[#232323] w-full px-8 py-8 h-screen  flex items-center justify-center"
      }
    >
      <img
        className="w-[8rem] h-[3rem] absolute top-0 left-0 m-8"
        src={logo_bitramp}
      />
      <div className="bg-[#2B2B2B] border border-[#464646] flex rounded-[0.625rem] justify-center gap-5 flex-col items-center w-[50rem] h-[20rem]">
        <div className={" white bold Subtitle"}>You Found a Secret Spot</div>
        <div className="text-[#9f9f9f] Text">
          This page isn’t open to the public. Want early access to the inside
          scoop?
        </div>
        <a
          href="https://bitramp.tech/contact"
          className={`${
            isBitramp()
              ? "Primary_button"
              : "Primary_button bg-[#ee33d9] hover:bg-[#b639a8]"
          } mt-[1.5rem]`}
        >
          Contact us
        </a>
      </div>
      {isBitramp() ? (
        <div className="flex flex-col items-center w-[4%] Text semi-bold fixed right-0 top-1/2 -translate-y-1/2">
          <div
            className="origin-top w-full flex justify-center items-center text-[#fff] absolute h-fit -top-[4.5rem] -right-2 overflow-hidden"
            style={{ writingMode: "vertical-rl" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="65"
              height="162"
              viewBox="0 0 65 162"
              fill="none"
            >
              <g filter="url(#filter0_d_4903_14514)">
                <path
                  d="M6.21265 23.7654C6.21839 19.5569 9.13983 15.9155 13.2467 14.998L55.2476 5.61404L55.106 135.614L12.4599 122.566C8.67067 121.406 6.08432 117.906 6.08972 113.944L6.21265 23.7654Z"
                  fill="#2B2B2B"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_4903_14514"
                  x="0.689844"
                  y="0.214258"
                  width="79.9577"
                  height="160.8"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="10" dy="10" />
                  <feGaussianBlur stdDeviation="7.7" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_4903_14514"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_4903_14514"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>

            <div
              onClick={() => navigate("/crmSoon")}
              className="absolute cursor-pointer top-10 flex flex-col font-bold text-white pt-[0.4rem]"
            >
              <div>CRM</div>
            </div>
          </div>
          <div
            className="rotate-270 origin-top w-full ml-[0.2rem] py-7 flex justify-center items-center text-[#000] z-[9]"
            style={{ writingMode: "vertical-rl" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="58"
              height="175"
              viewBox="0 0 65 175"
              fill="none"
            >
              <path
                d="M0.199469 18.9267C0.205123 14.5264 3.39181 10.7767 7.7334 10.0617L65.1059 0.613811L64.9098 174.114L7.63693 165.163C3.2501 164.477 0.0172863 160.695 0.0229917 156.255L0.199469 18.9267Z"
                fill="#8AFEFD"
              />
            </svg>
            <div
              onClick={() => navigate("/dashboard")}
              className=" cursor-pointer absolute text-[1.2rem] font-[700]"
            >
              Platform
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center w-[4%] Text semi-bold fixed right-0 top-1/2 -translate-y-1/2">
          <div
            className="origin-top w-full flex justify-center items-center text-[#fff] absolute h-fit -top-[4.5rem] -right-2 overflow-hidden"
            style={{ writingMode: "vertical-rl" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="65"
              height="162"
              viewBox="0 0 65 162"
              fill="none"
            >
              <g filter="url(#filter0_d_4903_14514)">
                <path
                  d="M6.21265 23.7654C6.21839 19.5569 9.13983 15.9155 13.2467 14.998L55.2476 5.61404L55.106 135.614L12.4599 122.566C8.67067 121.406 6.08432 117.906 6.08972 113.944L6.21265 23.7654Z"
                  fill="#fff"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_4903_14514"
                  x="0.689844"
                  y="0.214258"
                  width="79.9577"
                  height="160.8"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="10" dy="10" />
                  <feGaussianBlur stdDeviation="7.7" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_4903_14514"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_4903_14514"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>

            <div
              onClick={() => navigate("/crmSoon")}
              className="cursor-pointer absolute top-10 flex flex-col font-bold text-[#202A43]"
            >
              <div>CRM</div>
            </div>
          </div>
          <div
            className="rotate-270 ml-[0.3rem] origin-top w-full py-5 flex justify-center items-center text-[#fff] z-[9]"
            style={{ writingMode: "vertical-rl" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="58"
              height="175"
              viewBox="0 0 65 175"
              fill="none"
            >
              <path
                d="M0.199469 18.9267C0.205123 14.5264 3.39181 10.7767 7.7334 10.0617L65.1059 0.613811L64.9098 174.114L7.63693 165.163C3.2501 164.477 0.0172863 160.695 0.0229917 156.255L0.199469 18.9267Z"
                fill="#202A43"
              />
            </svg>
            <div
              onClick={() => navigate("/dashboard")}
              className="cursor-pointer absolute text-[1.2rem] font-[700]"
            >
              Platform
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CRMsoon;
